export const INPUT_SIZE_OPTIONS = {
  default: '',
  small: 'private-form__control--small'
};
export const USE_CLASSES = {
  default: '',
  'on-dark': 'private-form__control--on-dark'
};